import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './services/authContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Navigation from './components/Navigation';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import ArisansListPage from './pages/ArisansListPage';
import CreateArisanPage from './pages/CreateArisanPage';
import ArisanDetailPage from './pages/ArisanDetailPage';
import TransactionPage from './pages/TransactionPage';
import ProfilePage from './pages/ProfilePage';
import AdminUsersPage from './pages/AdminUsersPage';

import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <Navigation />
          <main className="main-content">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              {/* Protected routes */}
              <Route path="/" element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              } />
              <Route path="/arisans" element={
                <PrivateRoute>
                  <ArisansListPage />
                </PrivateRoute>
              } />
              <Route path="/create-arisan" element={
                <PrivateRoute>
                  <CreateArisanPage />
                </PrivateRoute>
              } />
              <Route path="/arisan/:id" element={
                <PrivateRoute>
                  <ArisanDetailPage />
                </PrivateRoute>
              } />
              <Route path="/arisan/:arisanId/:type/:memberId" element={
                <PrivateRoute>
                  <TransactionPage />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              } />
              <Route path="/admin/users" element={
                <AdminRoute>
                  <AdminUsersPage />
                </AdminRoute>
              } />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
